import { PawPrint, BadgeCheck, MapPin } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  "Piotrków Trybunalski",
  "Stargard",
  "Chełm",
  "Milanówek",
  "Rzezawa",
  "Hajnówka",
  "Sokółka",
  "Szumowo",
];

export const InstagramStoryVerified2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image as element for better html-to-image compatibility on iOS */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      {/* Green gradient overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(78,138,110,0.15) 0%, rgba(78,138,110,0.05) 100%)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content - 250px margins */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 60px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "16px",
              background: "#4E8A6E",
              borderRadius: "100px",
              padding: "16px 40px",
              marginBottom: "32px",
            }}
          >
            <BadgeCheck style={{ width: "40px", height: "40px", color: "#FFFFFF" }} />
            <span style={{ fontSize: "36px", fontWeight: 800, color: "#FFFFFF" }}>
              ZWERYFIKOWANE
            </span>
          </div>

          <h1
            style={{
              fontSize: "80px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
            }}
          >
            8 schronisk
          </h1>
          <p
            style={{
              fontSize: "40px",
              fontWeight: 600,
              color: "#4A7A5E",
              margin: "16px 0 0",
            }}
          >
            już z nami! 🎉
          </p>
        </div>

        {/* Grid of cities */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          {verifiedShelters.map((city, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.98)",
                borderRadius: "20px",
                padding: "24px 36px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                boxShadow: "0 6px 24px rgba(78,138,110,0.15)",
                border: "2px solid rgba(78,138,110,0.2)",
              }}
            >
              <MapPin style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
              <span style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D" }}>
                {city}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
              borderRadius: "24px",
              padding: "28px 48px",
              marginBottom: "24px",
            }}
          >
            <p
              style={{
                fontSize: "32px",
                fontWeight: 700,
                color: "#FFFFFF",
                margin: 0,
              }}
            >
              Sprawdź czego potrzebują 👆
            </p>
          </div>

          {/* Logo */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
